import { inputChangehandlers } from "../../helpers/formHandlers";
import {
  Container,
  Input,
  IsRequiredStar,
  Label,
  Span,
} from "../../Styles/Global.Styled";
import { css } from "styled-components";
import PasswordStrength from "../Password/PasswordStrength";

const cntStyle = (width, type, disabled) => css`
  flex-direction: column;
  width: ${width};
  justify-content: ${type === "number" ? "center" : null};
  opacity: ${disabled && "0.5"};
`;
const mbCntStyle = (width) => css`
  width: ${width};
`;
const labelDefault = css`
  position: absolute;
  height: 4vh;
  padding: 0 1vh;
`;
const labelActive = css`
  position: absolute;
  height: 1.3vh;
  top: -1vh;
  left: 0.5vh;
  background-color: white;
  font-size: 1.5vh;
  z-index: 2;
`;
const helperLabel = css`
  position: absolute;
  right: 0.3vw;
  bottom: -0.5vh;
  font-size: 0.9vh;
  background-color: white;
  z-index: 2;
`;
const inputStyle = (type, height) => css`
  width: 100%;
  height: ${height};
  padding: 0 1vh;
  border-radius: 12px;
  z-index: 1;
  text-align: ${type === "number" ? "center" : null};
`;
const errorTxt = css`
  color: red;
  font-size: 1.25vh;
`;

const TextInput = ({ properties, setForm, index, pairIndex, objectIndex }) => {
  const {
    width,
    height,
    mWidth,
    mHeight,
    label,
    type,
    inputMode,
    minLength,
    maxLength,
    required,
    value,
    errors,
    disabled,
    helperTxt,
    onChangeHandler,
    handleValidation,
  } = properties ?? {};

  const runValidation = () => {
    const handler = inputChangehandlers[handleValidation];
    if (handler) {
      handler(setForm, properties, index, pairIndex, objectIndex);
    }
  };

  const handleChange = (e) => {
    const { value } = e.target;

    const handler = inputChangehandlers[onChangeHandler];
    if (handler) {
      handler(setForm, index, value, pairIndex, objectIndex);
    }
    if (errors !== null) {
      runValidation();
    }
  };

  return (
    <Container
      $baseStyle={cntStyle(width, type, disabled)}
      $mStyle={mbCntStyle(mWidth, mHeight)}
    >
      <Label $baseStyle={value || value === 0 ? labelActive : labelDefault}>
        {label}
        {required && <IsRequiredStar />}
      </Label>
      <Input
        type={type}
        $error={errors}
        $baseStyle={inputStyle(type, height)}
        minLength={minLength}
        maxLength={maxLength}
        required={required}
        disabled={disabled}
        inputMode={inputMode}
        value={value}
        onChange={handleChange}
        onBlur={(e) => {
          if (errors === null) return runValidation(e);
        }}
      />
      {helperTxt && helperTxt !== "password" && (
        <Label $baseStyle={helperLabel}>{helperTxt}</Label>
      )}
      {helperTxt && type === "password" && (
        <PasswordStrength value={value} />
      )}
      {errors && <Span $baseStyle={errorTxt}>{errors}</Span>}
    </Container>
  );
};

export default TextInput;
